import { generateClassNameHelpers } from "./helpers/classname-helpers/classname-helpers";

export const { always, maybe, toggle, tw } = generateClassNameHelpers("");
